export const Defaults = {
    MaxExportCount: 100000,
    InventoryOutOfStockThreshold: 5,
    defaultSocialMediaImage: 'https://raisedonorsdev.azureedge.net/public/raise-donors/rd-base-meta-image.png'
}
